import axios from 'axios';

// Add additional axios config here if needed
axios.defaults.withCredentials = true;
axios.defaults.baseURL = '/';

export default axios;
